"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { ArtistActiveSubmissionContent } from "./ArtistActiveSubmissionContent";
import { ArtistWinningArtworksContent } from "./ArtistWinningArtworksContent";
import { ArtistPreviewModalHeader } from "./ArtistPreviewModalHeader";
import { ArtistPreviewModalTabs } from "./ArtistPreviewModalTabs";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ModalTab } from "./ArtistPreviewModal";
interface ArtistPreviewModalContentProps {
  readonly user: ApiProfileMin;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly isApp?: boolean;
  readonly activeTab: ModalTab;
  readonly onTabChange: (tab: ModalTab) => void;
  readonly hasWinningArtworks: boolean;
}
export const ArtistPreviewModalContent: React.FC<ArtistPreviewModalContentProps> = t0 => {
  const $ = _c(41);
  const {
    user,
    isOpen,
    onClose,
    isApp: t1,
    activeTab,
    onTabChange,
    hasWinningArtworks
  } = t0;
  const isApp = t1 === undefined ? false : t1;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const submissionCount = user.active_main_stage_submission_ids?.length || 0;
  const winnerCount = user.winner_main_stage_drop_ids?.length || 0;
  const hasActiveSubmissions = submissionCount > 0;
  const showTabs = hasActiveSubmissions && hasWinningArtworks;
  let currentContentType;
  if (showTabs) {
    currentContentType = activeTab;
  } else {
    if (hasWinningArtworks) {
      currentContentType = "winners";
    } else {
      currentContentType = "active";
    }
  }
  let t2;
  if ($[0] !== onClose || $[1] !== pathname || $[2] !== router || $[3] !== searchParams) {
    t2 = drop => {
      if (searchParams) {
        const params = new URLSearchParams(searchParams.toString());
        params.set("drop", drop.id);
        router.push(`${pathname}?${params.toString()}`);
      }
      onClose();
    };
    $[0] = onClose;
    $[1] = pathname;
    $[2] = router;
    $[3] = searchParams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDropClick = t2;
  let t3;
  if ($[5] !== currentContentType) {
    t3 = currentContentType === "winners" && <><div className="tw-absolute tw-inset-x-0 tw-top-0 tw-h-12 tw-pointer-events-none tw-bg-[linear-gradient(180deg,rgba(255,255,255,0.04),rgba(255,255,255,0)_70%)]" /><div className="tw-absolute tw-inset-0 tw-pointer-events-none tw-backdrop-blur-[1px]" /></>;
    $[5] = currentContentType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== currentContentType || $[8] !== isApp || $[9] !== onClose || $[10] !== submissionCount || $[11] !== user || $[12] !== winnerCount) {
    t4 = <ArtistPreviewModalHeader user={user} onClose={onClose} isApp={isApp} currentContentType={currentContentType} submissionCount={submissionCount} winnerCount={winnerCount} />;
    $[7] = currentContentType;
    $[8] = isApp;
    $[9] = onClose;
    $[10] = submissionCount;
    $[11] = user;
    $[12] = winnerCount;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== activeTab || $[15] !== onTabChange || $[16] !== showTabs) {
    t5 = showTabs && <ArtistPreviewModalTabs activeTab={activeTab} onTabChange={onTabChange} />;
    $[14] = activeTab;
    $[15] = onTabChange;
    $[16] = showTabs;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  bb0: {
    if (showTabs) {
      let t7;
      if ($[18] !== activeTab || $[19] !== handleDropClick || $[20] !== isApp || $[21] !== isOpen || $[22] !== onClose || $[23] !== user) {
        t7 = activeTab === "active" ? <ArtistActiveSubmissionContent user={user} isOpen={isOpen} onClose={onClose} isApp={isApp} /> : <ArtistWinningArtworksContent user={user} isOpen={isOpen} onDropClick={handleDropClick} />;
        $[18] = activeTab;
        $[19] = handleDropClick;
        $[20] = isApp;
        $[21] = isOpen;
        $[22] = onClose;
        $[23] = user;
        $[24] = t7;
      } else {
        t7 = $[24];
      }
      t6 = t7;
      break bb0;
    }
    if (hasWinningArtworks) {
      let t7;
      if ($[25] !== handleDropClick || $[26] !== isOpen || $[27] !== user) {
        t7 = <ArtistWinningArtworksContent user={user} isOpen={isOpen} onDropClick={handleDropClick} />;
        $[25] = handleDropClick;
        $[26] = isOpen;
        $[27] = user;
        $[28] = t7;
      } else {
        t7 = $[28];
      }
      t6 = t7;
      break bb0;
    }
    let t7;
    if ($[29] !== isApp || $[30] !== isOpen || $[31] !== onClose || $[32] !== user) {
      t7 = <ArtistActiveSubmissionContent user={user} isOpen={isOpen} onClose={onClose} isApp={isApp} />;
      $[29] = isApp;
      $[30] = isOpen;
      $[31] = onClose;
      $[32] = user;
      $[33] = t7;
    } else {
      t7 = $[33];
    }
    t6 = t7;
  }
  let t7;
  if ($[34] !== t5 || $[35] !== t6) {
    t7 = <div className="tw-flex-1 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 tw-relative">{t5}{t6}</div>;
    $[34] = t5;
    $[35] = t6;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  let t8;
  if ($[37] !== t3 || $[38] !== t4 || $[39] !== t7) {
    t8 = <div className="tailwind-scope tw-relative tw-rounded-xl tw-overflow-hidden tw-bg-[#0E1012] tw-border tw-border-white/5 tw-shadow-[0_10px_40px_rgba(0,0,0,0.55)]">{t3}{t4}{t7}</div>;
    $[37] = t3;
    $[38] = t4;
    $[39] = t7;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  return t8;
};